import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
//import filter modal
import FilterModal from "components/Modal/FilterModal";
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  postRequestForm,
  deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const NotificationManagement = (props) => {
  const [modal_center, setmodal_center] = useState(false);
  const [Categorydata, setCategorydata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [value, setValue] = React.useState(10);

  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");

  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [sizeList, setSizeList] = useState([]);
  const [model, setModel] = useState(false);
  const [canCreate, setCanCreate] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canExport, setCanExport] = useState(true);
  const [filter, setFilter] = useState({ ...filterObj });

  const [loader2, setLoader2] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, [currentPage]);

  useEffect(() => {
    fetchNotifications();
  }, [sort, sortOrder, sizePerPageOrg]);

  const GetValueOnChange = async (isActive, item) => {

    const payload = {
      id: item?._id,
      question: item?.question,
      answer: item?.answer,
      isPublished: isActive == true ? false : true,
      isDeleted: item?.isDeleted,
    }
    const res = await postRequest("support/quick-question/update", payload);
    if (res.status) {
      toast.success(res.message);
      fetchNotifications();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };
  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  const updateFilter = (key, value) => {
    const filterObj = { ...filter };
    filterObj[key] = value;
    setFilter(filterObj);
  };

  const applyFilter = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });

    console.log("filterArgs", filterArgs);
    toggleModel();
    fetchNotifications(filterArgs);
  };

  const getFilters = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });
    return filterArgs;
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    fetchNotifications();
  };

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }

  function ImageFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row?.image}
          onClick={() => showLightBox(row?.image)}
          alt="user"
          width={"50px"}
        />
      </>
    );
  }

  function DateFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center">
        {moment(row?.createdAt).format("DD-MM-YYYY hh:mm")}
      </div>
    );
  }
  function DateFormatter2(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center">
        {row?.scheduled ? <> {moment.utc(row?.scheduledDateTime).format("DD-MM-YYYY HH:mm")} </> :
          <> {moment(row?.createdAt).format("DD-MM-YYYY hh:mm")}</>}
      </div>
    );
  }

  function ImgCoverFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.cover}
          // onClick={() => showLightBox(row.cover)}
          alt="cover img"
          width={"50px"}
        />
      </>
    );
  }


  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }


  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    // {
    //   text: "User Image",
    //   formatter : ImageFormatter,
    //   sort: false,
    // },
    {
      dataField: "type",
      text: "Notifications Type",
      sort: false,
    },
    {
      dataField: "title",
      text: "Title",
      sort: false,
    },
    {
      dataField: "description",
      text: "Description",
      sort: false,
    },

    {
      formatter: DateFormatter,
      text: "Created At",
      sort: false,
    },
    {
      formatter: DateFormatter2,
      text: "Scheduled DateTime",
      sort: false,
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      formatter: statusFormatter,
    },
    {
      dataField: "Status",
      text: "Action",
      formatter: iconFormatter,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchNotifications(null, event.target.value);
    }
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
  };

  function iconFormatter(cellContent, row) {
    return (
      <div className="d-flex justify-content-center gap-2">
        {!row?.status ? <>
          <button type="button" className=" btn btn-primary">
            <Link
              to={{
                pathname: `/updateNotification`,
                state: { row },
              }}
            >
              <i className="fal fa-edit fs-5 text-light"></i>
            </Link>
          </button>

          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handlerdelete(row._id)}
          >
            <i className="fal fa-trash  fs-5"></i>
          </button></>
          : <>
            <button type="button" className=" btn btn-primary">
              <Link
                to={{
                  pathname: `/updateNotification`,
                  state: { row, 'viewMode' : "viewMode" },
                }}
              >
                <i className="fal fa-eye fs-5 text-light"></i>
              </Link>
            </button>
            <button
              disabled
              type="button"
              className="btn btn-danger"
              onClick={() => handlerdelete(row._id)}
            >
              <i className="fal fa-trash  fs-5"></i>
            </button>
          </>}
      </div>
    );
  }
  function statusFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">

        {row?.status ? <>
          <span className="" style={{ color: 'green' }}><b>Delivered</b></span>
        </> : <span className="text-danger"><b>Upcoming</b></span>}
      </div>
    );
  }

  const limit = 10;

  const exportCSV = async () => {
    setLoader(true);

    const filterArgs = getFilters();
    const payload = {
      sortField: sort,
      sortOrder: sortOrder,
    };
    // if (filterArgs?.length) {
    //   payload.filterArgs = filterArgs;
    // } else {
    //   if (searchText) {
    //     payload.search = searchText;
    //   }
    // }
    try {
      const response = await postRequest(`Category/export-csv`, payload);
      const data = response.data;
      window.location.href = data.url;
      console.log("data", data);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchNotifications = async (limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      search: searchText,
      sortOrder: sortOrder,
    };
    try {
      const response = await postRequest(`notification/list`, payload);
      const data = response.data;

      setTotalPage(data?.count);
      setCurrentFPage(data?.page);
      setCategorydata(data?.list || []);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };


  const handlerdelete = (id, ids) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Notification",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        showRandomWordDialog(id, ids);
      }
    });
  };

  const showRandomWordDialog = (id, ids) => {
    const randomIndex = Math.floor(
      Math.random() * deleteConfirmationWords.length
    );
    const randomWord = deleteConfirmationWords[randomIndex];

    Swal.fire({
      title: "Confirmation Required",
      text: `To confirm deletion, please enter the word: ${randomWord}`,
      icon: "warning",
      input: "text",
      inputPlaceholder: `Type '${randomWord}' to confirm`,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed && result.value === randomWord) {
        deleteRequestFunction(id, ids);
      } else if (result.isConfirmed) {
        Swal.fire(
          "Incorrect Entry",
          "Please enter the correct word to confirm.",
          "error"
        );
      }
    });
  };

  const deleteRequestFunction = async (id, ids) => {
    const response = await postRequest("notification/remove", { notificationId: id });
    if (response.status) {
      Swal.fire("Deleted!", "Deleted successfully");
      fetchNotifications();
    } else {
      Swal.fire("Error!", "Something went wrong");
    }
  };

  function activeFormatter(cellContent, row) {
    const isActive = row.isPublished;
    return (
      <button
        className={`btn ${isActive ? 'btn-active' : 'btn-deactive'}`}
        type="button"
        onClick={() => GetValueOnChange(isActive, row)}
      >
        {isActive ? 'Published' : 'UnPublished'}
      </button>
    );
  }

  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Notification Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Notification Management</li>:{" "}
                <li className="breadcrumb-item">Notification List</li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 text-end">

            <Link to="/createNotification">
              {" "}
              <Button>
                {" "}
                <i class="fas fa-plus"></i> Create
              </Button>{" "}
            </Link>
            &nbsp;&nbsp;&nbsp;
          </div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Categorydata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  {/* <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="title">Title Name</option>

                                    <option value="description">
                                      Description
                                    </option>
                                  </select> */}
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="filter-item" style={{ width: '86.5%' }}>
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchNotifications();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                    {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}
      </React.Fragment>

    </>
  );
};

export default NotificationManagement;
